import React, { Component } from 'react';
import {
    Nav, NavDropdown, MenuItem
} from 'react-bootstrap';
import AuthService from '../../services/AuthService.js';
import NotificationService from '../../services/NotificationService.js';

const Auth = new AuthService();

class HeaderLinks extends Component{
  constructor(props) {
    super(props);
    this.state = {
      notificaciones: null,
      notifError: false,
    };
    this.notificationService = new NotificationService();
    this.getUnreadNotifications = this.getUnreadNotifications.bind(this);
    this.clickNotificacion = this.clickNotificacion.bind(this);
    this.generateNotifications = this.generateNotifications.bind(this);
  }
  componentWillMount() {
    this.getUnreadNotifications();
  }


  componentDidMount() {
    this.interval = setInterval(() => this.getUnreadNotifications(), 15000);
  }
  componentWillUnmount() {
    clearInterval(this.interval);
  }

  getUnreadNotifications() {
    this.notificationService.getUnreadedNotifications()
    .then(res => {
      this.setState({
        notificaciones: res.notificaciones,
        notificationCount: res.notificaciones.length,
        notifError: false,
      });
    })
    .catch(err => {
      this.setState({ notifError: true });
    });
  }

  clickNotificacion(path, id) {
    this.notificationService.markNotificationAsRead(id)
    .then(res => {
      this.props.history.push(path);
      this.getUnreadNotifications();
    });
  }

  generateNotifications() {
    if (!this.state.notificaciones) {
      return (<MenuItem disabled>Cargando...</MenuItem>);
    }
    if (this.state.notifError) {
      return (<MenuItem disabled>Hubo un error al cargar las notificaciones</MenuItem>);
    }
    if (this.state.notificaciones.length === 0) {
      return (<MenuItem disabled>No tienes nuevas notificaciones</MenuItem>);
    } else {
      return this.state.notificaciones.map((item, index) => {
        return <MenuItem key={index} onClick={() => this.clickNotificacion(item.path, item.id)}>{item.descripcion}</MenuItem>
      });
    }
  }

  render(){
    return(
      <div>
        <Nav pullRight>
          <NavDropdown
            eventKey={4}
            title={(
              <div>
                <i className="fa fa-bell-o"></i>
                {this.state.notificaciones && this.state.notificationCount > 0 &&
                  <span className="notification">
                    {this.state.notificationCount}
                  </span>
                }
                <p className="hidden-md hidden-lg">
                  Notificaciones
                  <b className="caret"></b>
                </p>
              </div>
            )} noCaret id="basic-nav-dropdown-2">
            {this.generateNotifications()}
          </NavDropdown>
          <NavDropdown
            eventKey={4}
            title={(
              <div>
                <i className="fa fa-list"></i>
                <p className="hidden-md hidden-lg">
                  Más
                  <b className="caret"></b>
                </p>
              </div>
            )} noCaret id="basic-nav-dropdown-3" bsClass="dropdown-with-icons dropdown">
            <MenuItem eventKey={4.2} onClick={this.handleLogout.bind(this)}><div className="text-danger"><i className="pe-7s-close-circle"></i> Salir</div></MenuItem>
          </NavDropdown>
        </Nav>
      </div>
        );
    }
    handleLogout(){
      Auth.logout();
      window.location='/#/login';
    }
}
export default HeaderLinks;



// WEBPACK FOOTER //
// ./src/components/Header/HeaderLinks.jsx